import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Store, Search, ShoppingBag, User } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function MobileNav() {
  const { count } = useCart();
  const loc = useLocation();
  const navigate = useNavigate();
  const items = [
    { label: "Home", to: "/", icon: Home },
    { label: "Shop", to: "/shop", icon: Store },
    { label: "Search", to: "/shop?focus=1", icon: Search },
    { label: "Cart", to: "/cart", icon: ShoppingBag, badge: count },
    { label: "Account", to: "/account", icon: User },
  ];
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-slate-200 md:hidden flex justify-around items-center h-16 px-2" data-testid="mobile-bottom-nav">
      {items.map((it) => {
        const active = loc.pathname === it.to.split("?")[0];
        const Icon = it.icon;
        return (
          <button key={it.label} onClick={() => navigate(it.to)}
            data-testid={`bottomnav-${it.label.toLowerCase()}`}
            className={`relative flex flex-col items-center justify-center gap-0.5 flex-1 h-full ${active ? "text-teal" : "text-slate-500"}`}>
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{it.label}</span>
            {it.badge > 0 && (
              <span className="absolute top-2 right-1/4 bg-teal text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-1">{it.badge}</span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
